import Nav from 'react-bootstrap/Nav';
import styles from './categoryNav.module.scss';
import { useTranslation } from 'next-i18next';
import translationFallback from '@/utilites/translations/translationFallback';
import uiItems from '@/constants/ui-items/index.constants';
import { useRouter } from 'next/router';
import DefaultButton from '../common/default/DefaultButton';

const CategoryNav = ({ userId }: { userId: string | null }) => {
  const { push, pathname } = useRouter();
  const { t: tCommon } = useTranslation('common');

  const handleNavClick = (href: string) => {
    push(href);
  };

  return (
    <div className={styles.sliderWrapper}>
      <Nav
        className={`${styles.hover} ${styles.sliderNav} position-relative z-index-1 !tw-justify-center tw-pb-2 max-nine:tw-m-auto max-nine:tw-mb-2 max-nine:tw-flex max-nine:tw-gap-4 max-nine:!tw-px-4`}
      >
        {uiItems.categoryNavItems.map((item, index) => (
          <Nav.Item key={index} className="px-lg-5">
            <Nav.Link
              as={DefaultButton}
              className="text-decoration-none tw-rounded-full !tw-px-3 !tw-py-1.5 !tw-font-bold !tw-text-text max-nine:!tw-p-0 max-nine:!tw-font-semibold"
              onClick={() => handleNavClick(item.href)}
            >
              {translationFallback(item.tKey, tCommon(item.tKey), item.tFallback)}
            </Nav.Link>
          </Nav.Item>
        ))}
      </Nav>
    </div>
  );
};

export default CategoryNav;
